const signinPath = '/signin';

export const appPaths = {
  dashboard: () => '/',
  document: {
    path: () => '/document/:documentId',
    navigate: ({ documentId }: { documentId?: string }) => `/document/${documentId}`,
  },

  signin: {
    path: () => signinPath,
    navigate: (options?: { accountId?: string; refUrl?: string; username?: string; signup?: boolean }) => {
      const url = new URL(signinPath, window.location.origin);
      if (options) {
        if (options.accountId) {
          url.searchParams.set('a', options.accountId);
        }
        if (options.refUrl) {
          url.searchParams.set('refUrl', options.refUrl);
        }
        if (options.username) {
          url.searchParams.set('username', options.username);
        }
        if (options.signup) {
          url.searchParams.set('signup', '1');
        }
      }

      return url.pathname + url.search;
    },
  },
  signup: {
    path: () => '/signup',
    navigate: (refUrl?: string) => {
      if (refUrl) {
        return `/signup?refUrl=${refUrl}`;
      }
      return `/signup`;
    },
  },
  task: {
    path: () => '/tasks/:taskId',
    navigate: ({ taskId }: { taskId?: string }) => `/tasks/${taskId}`,
  },
  taskList: {
    path: () => '/tasks',
    navigate: () => `/tasks`,
  },

  unit: {
    path: () => '/units/:unitId',
    navigate: ({ unitId }: { unitId?: string }) => `/units/${unitId}`,
  },
  unitList: {
    path: () => '/units',
    navigate: () => `/units`,
  },
  contract: {
    path: () => '/contracts/:contractId',
    navigate: ({ contractId }: { contractId?: string }) => `/contracts/${contractId}`,
  },
  contractList: {
    path: () => '/contracts',
    navigate: () => `/contracts`,
  },
  invoiceList: {
    path: () => '/invoices',
    navigate: () => `/invoices`,
  },
  invoice: {
    path: () => '/invoices/:invoiceId',
    navigate: ({ invoiceId }: { invoiceId?: string }) => `/invoices/${invoiceId}`,
  },
  expenseList: {
    path: () => '/expenses',
    navigate: () => `/expenses`,
  },
  expense: {
    path: () => '/expenses/:expenseId',
    navigate: ({ expenseId }: { expenseId?: string }) => `/expenses/${expenseId}`,
  },
  recurringInvoice: {
    path: () => '/recurring-invoices/:recurringInvoiceId',
    navigate: ({ recurringInvoiceId }: { recurringInvoiceId?: string }) => `/recurring-invoices/${recurringInvoiceId}`,
  },
  moneyTransactionList: {
    path: () => '/money-transactions',
    navigate: () => `/money-transactions`,
  },
  profile: {
    path: () => '/profile/:userId',
    navigate: (userId: string, refresh?: boolean) => '/profile/' + userId + (refresh ? '?refresh=1' : ''),
  },
  account: {
    path: () => '/account',
    navigate: () => '/account',
  },
  notificationSettings: {
    path: () => '/notification-settings',
    navigate: () => '/notification-settings',
  },
  privacy: () => '/privacy',
  terms: () => '/terms',
  invitation: {
    path: () => '/invitation',
    navigate: (accountId?: string, token?: string) => `/invitation/?a=${accountId}&token=${token}`,
  },
  passwordForgot: {
    path: () => '/password-forgot',
    navigate: () => '/password-forgot',
  },
  passwordReset: {
    path: () => '/password-reset',
    navigate: () => '/password-reset',
  },
  emailVerification: {
    path: () => '/email-verification',
    navigate: (email?: string) => `/email-verification${email ? `?email=${encodeURIComponent(email)}` : ''}`,
  },
  verifyEmail: {
    path: () => '/verify-email',
    navigate: (token?: string) => `/verify-email${token ? `?token=${token}` : ''}`,
  },
};
